export const HEADER_ENTER_EMAIL =
  'Enter your email and receive a code to reset your password';
export const HEADER_ENTER_CODE = 'Reset your password';
export const HEADER_FORGOT_PASSWORD = 'Forgot your password?';
